export default "__VITE_ASSET__CkuH61HH__"